import { ApplicationTypeByMembers } from './types';

export const applicationTypeQuestions: Record<string, any> = {
  applicationType: {
    labelKey: 'applicationForm.APPLICATION_TYPE.isSoleApplication.labelKey',
    options: [
      {
        value: ApplicationTypeByMembers.SOLE_APPLICATION,
        labelKey: 'applicationForm.APPLICATION_TYPE.soleApplication.labelKey',
      },
      {
        value: ApplicationTypeByMembers.JOINT_APPLICATION,
        labelKey: 'applicationForm.APPLICATION_TYPE.jointApplication.labelKey',
      },
    ],
  },
};
